import { Disclosure } from '@headlessui/react'
import { Outlet } from 'react-router-dom';
import SpeciesMenu from './components/SpeciesMenu';

const navigation = [
  { name: 'Home', href: '/', current: false },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Layout = (props) => {

    const { colorBg, logoHeader, showSpecies, setShowSpecies } = props;

    return (
      <html className="h-full bg-white">
        <head>
          <meta charSet="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <link href="/dist/output.css" rel="stylesheet" />
        </head>
        <body className="h-full">
        <div className="min-h-full">
          <Disclosure as="nav" className={colorBg}>
            {({ open }) => (
              <>
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                  <div className="flex h-16 items-center justify-between">
                    <div className="flex items-center">
                      <div><p><b>PlantaeViz</b></p></div>
                      <div className="flex-shrink-0">
                        <div className="w-10 h-8 bg-no-repeat bg-center bg-contain" style={{backgroundImage:"url('/PlantViz_images/PlantViz_logo.svg')"}} alt="logo"></div>
                      </div>
                      <div className="hidden md:block">
                        <div className="ml-10 flex items-baseline space-x-4">
                          {navigation.map((item) => (
                            <a
                              key={item.name}
                              href={item.href}
                              className={classNames(
                                item.current
                                  ? 'bg-gray-900 text-white'
                                  : 'text-gray-300 hover:bg-black/30 hover:text-white',
                                'rounded-md px-3 py-2 text-sm font-medium'
                              )}
                              aria-current={item.current ? 'page' : undefined}
                            >
                              {item.name}
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Disclosure>

          <header className="bg-white shadow" style={{height: "450px"}}>
              <div className="w-80 h-60 bg-cover bg-center bg-no-repeat mx-auto" style={{width: "100%", height: "500px", backgroundImage: "url("+logoHeader+")"}}></div>
          </header>
          <main>
            <div className="bg-gray-100 w-full py-7 px-10">
              <SpeciesMenu showSpecies={showSpecies} setShowSpecies={setShowSpecies}></SpeciesMenu>
            </div>
            <div className="mx-auto py-6 sm:px-6 lg:px-8" style={{maxWidth: "1400px"}}>
                <Outlet /></div>
          </main>
        </div>
        </body>
      </html>
    );
}

export default Layout;
